/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Fri Mar 15 2024
 **/

import { createContext } from "react";

export const FileBoxContext = createContext<
	FileBox.Context.OpenByUnity | FileBox.Context.OpenByMyDesk | FileBox.Context.OpenByWhiteboard | undefined
>(undefined);

export default function FileBoxProvider({
	value = undefined,
	children
}: {
	value: FileBox.Context.OpenByUnity | FileBox.Context.OpenByMyDesk | FileBox.Context.OpenByWhiteboard | undefined;
	children: React.ReactNode;
}) {
	return <FileBoxContext.Provider value={value}>{children}</FileBoxContext.Provider>;
}
